import React from 'react';

import "../styles/spinner.css";


class Spinner extends React.Component {


    render() {
        let size = 60;
        let borderColor = '#f3f3f3';
        let borderTopColor = '#3498db';

        var margin = -1 * (size / 2);
        var borderWidth = 2 * size / 15;
        var minHeight = (borderWidth + size) * 1.41;
        return (
            <div className='mg-react-spinner' style={{ minHeight: minHeight }}>
                <div className='mg-react-spinner__main l-center' 
                     style={{ width: size, height: size,
                              marginTop: margin, marginLeft: margin,
                              borderWidth: borderWidth, borderColor: borderColor,
                              borderTopColor: borderTopColor }}>
                </div>
            </div>
        )
    }
};

export default Spinner;


// WEBPACK FOOTER //
// ./src/components/spinner.js